<template>
  <div class="manage-quantity">
    <div class="qty-holder">
      <span>{{nowQty}}</span>
    </div>
    <div class="add">
      <button class="btn btn-none mn-qty" @click.prevent="manageQty(1)" :disabled="(nowQty >= maxQty)">
        <svg class="o-icon"><use xlink:href="#plus"></use></svg>
      </button>
    </div>
    <div class="minus">
      <button class="btn btn-none mn-qty" @click.prevent="manageQty(0)">
        <svg class="o-icon"><use xlink:href="#minus"></use></svg>
      </button>
    </div>
    <div class="block-apply">
      <slot name="apply"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManageQuantity',
  props: {
    minQty: {
      type: Number,
      default: 1
    },
    maxQty: {
      type: Number,
      required: true
    },
    incrementStep: {
      type: Number,
      default: 1
    },
    currentQty: {
      type: Number,
      required: false,
      default: 1
    },
    reachZero: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nowQty: {
      get () {
        return this.currentQty
      },
      set (newValue) {
        this.$emit('update:currentQty', newValue)
      }
    }
  },
  methods: {
    manageQty (operator) {
      if (operator) {
        // ADD
        this.nowQty += this.incrementStep
      } else {
        if (this.nowQty > this.incrementStep) {
          this.nowQty -= this.incrementStep
        }
      }
    }
  }
}
</script>
